import { Middleware } from 'redux';

/**
 * Allows dispatching JS class actions.
 *
 * @example
 *
 * class Foo {
 *    readonly type = 'FOO';
 *    readonly payload;
 *    constructor(public payload) {}
 * }
 *
 * dispatch(new Foo(1))
 * // is the same as
 * dispatch({ type: 'FOO', payload: 1 });
 */
const classActions: Middleware = store => next => action => {
  next({ ...action });
};

export default classActions;
